<template>
  <span>
    <div v-if="$apollo.queries.queriedOrganisation.loading">
      {{ $t("common:loading.messsage", "Loading...", "Loading message") }}
    </div>
    <v-tooltip
      v-else-if="displayOrganisation"
      bottom
      :disabled="showFullName || !displayOrganisation.shortName"
    >
      <template #activator="{ on, attrs }">
        <AppShowTopOrganisationLogo
          v-if="showLogo && displayOrganisation.logoPath"
          :organisation="displayOrganisation"
          class="ml-1"
          image-style="max-height: 20px;max-width: 54px"
        />
        <router-link
          :to="{
            name: 'OrganisationProfilePage',
            params: { organisationId: displayOrganisation.id }
          }"
          v-bind="attrs"
          class="no-default-link-style"
          v-on="on"
        >
          {{
            showFullName
              ? displayOrganisation.name
              : displayOrganisation.shortName || displayOrganisation.name
          }}
          {{ showIdentifier ? `(${displayOrganisation.identifier})` : "" }}
        </router-link>
      </template>
      <span>
        {{ displayOrganisation.name }}
      </span>
    </v-tooltip>
  </span>
</template>
<script>
import gql from "fraql";
import AppShowTopOrganisationLogo from "@AppShows/organisation/AppShowTopOrganisationLogo.vue";

export default {
  name: "AppShowOrganisationName",
  components: {
    AppShowTopOrganisationLogo
  },
  props: {
    organisation: {
      type: [Object, String],
      default: null
    },
    showFullName: {
      type: Boolean,
      default: false
    },
    showIdentifier: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      queriedOrganisation: null
    };
  },
  computed: {
    displayOrganisation() {
      if (
        typeof this.organisation === "string" ||
        this.organisation instanceof String
      ) {
        return this.queriedOrganisation || { id: this.organisation };
      } else {
        return this.organisation;
      }
    }
  },
  fragments: {
    organisation: gql`
      fragment _ on Organisation {
        id
        name
        shortName
        logoPath
        identifier
      }
    `
  },
  apollo: {
    queriedOrganisation: {
      query: gql`
        query showOrganisationName($id: ID) {
          organisation(id: $id) {
            id
            name
            shortName
            logoPath
            identifier
          }
        }
      `,
      variables() {
        return {
          id: this.organisation
        };
      },
      skip() {
        return !(
          typeof this.organisation === "string" ||
          this.organisation instanceof String
        );
      },
      update: ({ organisation }) => organisation
    }
  }
};
</script>
